// extracted by mini-css-extract-plugin
export default {"Identity":"Identity_Identity__Z+azO"};